export enum CommitReferenceType {
    THIS,
    OTHER
}
